import workspace from "../../workspace";
import RenderParts from "../../../helpers/renderParts";
import RenderFigures from "../../../helpers/renderFigures";
import COLOR_THEMES from "../../../store/colorThemes";
import sqftConfig from "../../../store/sqftConfig";

class ShapeSpacer {
  __shape;

  constructor(shape) {
    this.__shape = shape;
  }

  import = (data) => {
    void data
  }

  export = () => {
    return {
    }
  }

  render = (ctx, staticOffset = null) => {
    if (workspace && workspace.getState().loading) return;

    this.renderBorders(ctx, staticOffset);
    if (!this.__shape.shapeAbsolute.getAbsolutePosition() && !this.__shape.shapeAbsolute.getSnappedWithShape()) {
      //this.renderCrownMolding(ctx);
      this.renderDimensionsOutsideShape(ctx);
    }
  }

  renderBorders = (ctx,
                   staticOffset = null,
  ) => {
    RenderParts.drawSpacerBorders(ctx, staticOffset, this.__shape);
  };

  renderDimensionsOutsideShape = (ctx) => {
    ctx.save();
    ctx.beginPath();
    ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].primary_hover;
    this.renderMeasurementArrows(ctx);
    this.renderMeasurementLength(ctx);
    ctx.closePath();
    ctx.restore();
  }

  renderMeasurementArrows = (ctx) => {
    const points = this.__shape.getPointsPointField();
    void ctx; void points;
    RenderFigures.drawArrowsAroundPoints(ctx, points, 10)
  }

  renderMeasurementLength = (ctx) => {
    const points = this.__shape.getPointsPointField();
    RenderParts.drawMeasurementAroundPoints(ctx, points);
  }

}

export default ShapeSpacer
